module.exports = __webpack_public_path__ + "img/credit-one-club-gal-3.d7ca94d5.jpg";